// vim: sts=2:ts=2:sw=2
/* jshint undef: true, unused: true */
/* jshint browser: true */

import jQuery from 'jquery';
import {charting} from './chart_base.js';

const $ = jQuery;

$(document).ready(function(){

  var table = function($container, table_id){

    if ($container.length === 0)
      return;

    // there is the minimal version for the overview page and the normal version for the log viewer
    var minimal = ($(table_id).data("minimal") == "1");

    // set table css width so that browser layout does (hopefully) not change
    var width = "100%";
    if (minimal){
      width = charting.width + "px";
      $(table_id).width(width);
    }

    $container.find("form").submit(function(evt){
      evt.preventDefault();
      datatable.ajax.url(charting.url($container, table_id)).load();
    });

    var $table = $('<table class="table table-condensed table-hover" />');
    var $thead = $(
      "<thead><tr>" +
      "<th></th>" + // no name - so this column will not appear in column-visibility-button
      "<th>Host</th>" +
      "<th>Type</th>" +
      "<th>Path (regexp)</th>" +
      "<th>Count Total</th>" +
      "<th>Count Week</th>" +
      "<th>Action</th>" +
      "</tr></thead>");
    var $tbody = $("<tbody></tbody>");
    $table.append($thead);
    $table.append($tbody);
    $table.width(width);
    $(table_id).html($table);
    var datatable = $table
      .on('xhr.dt', function ( e, settings, json/*, xhr*/ ) {
        // preprocess server data - manipulate the data directly in the JSON object.
        if (json)
          json = json.data;
        else
          json = {}; // error case
//                $.each( json, function(idx, elm) {
                  // preprocess data
//                    elm.request.headers_parsed = JSON.parse(elm.request.headers);
//                });
      })
      .DataTable({
        ajax: charting.url($container, table_id),
        paging: false,
        sDom: minimal ? '<"top">rt<"bottom"lp><"clear">' : '<"top"iB>rt<"bottom"lp><"clear">', // no filter (=search field)
        order: [[ 1, "asc" ]], // default sort order
      language: {
            info: "Showing _TOTAL_ records",
            infoEmpty: "Showing 0 records"
        },
        columns: [
          {
            // enumerate column
            data: undefined,
            visible: !minimal,
            className: "dt-right",
            mRender: function(data/*, type, full*/){
              return (typeof(data) !== 'undefined')? data : ""; // "" is just a dummy
            },
            orderable: false
          },
          {
            data: "host",
            visible: true,
            orderable: true,
            mRender: function(data, type/*, full*/){
              if (type === 'display')
                return $("<div>").text(data).html();
              return data;
            }
          },
          {
            data: "is_type.str",
            visible: true,
            orderable: true,
            mRender: function(data, type/*, full*/){
              if (type === 'display'){
                if (data === "se")
                  return "search engine";
                return data;
              }
              return data;
            },
          },
          {
            data: "paths",
            visible: true,
            orderable: false,
            mRender: function(data, type/*, full*/){
              var idx;
              if (type === 'display'){
                // create a comma separted string containing the error strings
                var paths = "";
                for (idx=0 ; idx < data.length; idx++)
                {
                  if (idx > 0)
                    paths += "<br/>";
                  paths += $("<div>").text(data[idx].path).html();
                }
                return paths;
              }
              return data;
            },
          },
          {
            data: "count",
            visible: true,
            orderable: true
          },
          {
            data: "daycount_sum",
            visible: true,
            orderable: true
          },
          {
            data: "lnk_edit",
            visible: true,
            orderable: false,
            mRender: function(data, type/*, full*/){
              if (type === 'display'){
                if (typeof(data) === "undefined")
                  return "";
                return $("<a>[edit]</a>").attr("href", data).wrap('<div/>').parent().html();
              }
              return ""; // dummy
            },
          },
        ],
        rowCallback: function (nRow, aData/*, iDisplayIndex, iDisplayIndexFull*/) {
          // highlight rows
          if (aData.is_type.str === "se")
            $(nRow).addClass('warning');
          else if (aData.is_type.str === "spam")
            $(nRow).addClass('danger');
        },
        drawCallback: function(/*settings*/) {
          // update the enumeration column
          this.api().rows().every( function ( rowIdx, tableLoop, rowLoop ) {
            datatable.cell( rowIdx, 0 ).data(rowLoop+1);
            this.cell(0).render(0);
          });
        }
      });
  };

  $(".table_requests").each(function(){
      var $container = $(this);
      charting.unique_id($container.find(".content"));
      var $table = $container.find(".content");
      var table_id = $table.attr('id');
      table($container, "#"+table_id);
  });
});
